import React from 'react';
import Alert from "Components/DesignSystem/Alert/Alert";
import Spinner from "Components/DesignSystem/Spinner/Spinner";

/**
 * The category accordions' status strip on DS Alert + Spinner — the third of the
 * byte-similar copies § 99 predicted would come up (Products § 74, Rules § 99,
 * now here). Same grammar: Saving/Loading are info with an aria-hidden Spinner
 * (the Alert is the live region), Error is danger, Success renders only while
 * `message !== undefined` — the shipped quirk, preserved and pinned.
 *
 * ⚠ Non-urgent strips are polite `role="status"` now; only Error is
 * `role="alert"` (legacy put role="alert" on all four).
 *
 * `data-testid` comes from the CALLER — up to seven accordions render this on
 * one page, and a baked-in id would duplicate the moment two are open (the
 * § 4 one-testid-one-element rule).
 */
/**
 * @param {{ loading: { status: string | null, message?: import('react').ReactNode }, 'data-testid'?: string }} props
 */
const LoadingSuccessErrorAlert = ({ loading, "data-testid": dataTestId }) => {
  if (loading.status === "Saving" || loading.status === "Loading") {
    return (
      <Alert tone="info" live data-testid={dataTestId}>
        <span className="tw-inline-flex tw-items-center tw-gap-2">
          <Spinner size="sm" aria-hidden="true" />
          <span>{loading.message}</span>
        </span>
      </Alert>
    );
  }
  if (loading.status === "Error") {
    return (
      <Alert tone="danger" live data-testid={dataTestId}>
        {loading.message}
      </Alert>
    );
  }
  if (loading.status === "Success" && loading.message !== undefined) {
    return (
      <Alert tone="success" live data-testid={dataTestId}>
        {loading.message}
      </Alert>
    );
  }
  return null;
};

export default LoadingSuccessErrorAlert;
